// extracted by mini-css-extract-plugin
export default {"content":"GroupPaymentResult-modules__content__FC7il"};